import React from "react";
import styles from "./Organisationsform.module.css";
import cardStyles from "./Card.module.css";
import {FaCircleCheck, FaRegHourglassHalf} from "react-icons/fa6";
import {TbAccessPoint, TbTargetArrow} from "react-icons/tb";
import { LuBookOpenText } from "react-icons/lu";
import { IoDocumentTextOutline } from "react-icons/io5";
import {GrVulnerability} from "react-icons/gr";
import {BsClockHistory} from "react-icons/bs";
import {FaRegCalendarCheck} from "react-icons/fa";

const features =[
    {
    icon:<FaCircleCheck />,
    title:"Voraussetzung",
    content:
        <div>
            <p>✔ Versetzungszeugnis in die Einführungsphase der gymnasialen Oberstufe</p>
            <p>✔ mittlere Reife</p>
            <p style={{ fontWeight: "500", color:"#3d4666"}}>sowie</p>
            <p>✔ Abschlussprüfung in einem  anerkannten Ausbildungsberuf</p>
            <p style={{ fontWeight: "500", color:"#3d4666"}}>oder</p>
            <p>✔ Abschluss einer min. 2-jährigen  Berufsausbildung (staatliche Prüfung)</p>
            <p style={{ fontWeight: "500", color:"#3d4666"}}>oder</p>
            <p>✔ Laufbahnprüfung im öffentlichen Dienst</p>
            <p style={{ fontWeight: "500", color:"#3d4666"}}>oder</p>
            <p>✔ min. 3-jährige berufliche Tätigkeit in einem Betrieb</p>
        </div>,
    },
    {
        icon: <BsClockHistory />,
        title: "Unterrichtszeiten",
        content: "32 Wochenstunden / Montag bis Freitag"
    },
    {
        icon: <FaRegHourglassHalf />,
        title: "Dauer",
        content: "12 Monate"
    },
    {
        icon:<TbTargetArrow />,
        title:"Zielgruppe",
        content: <div><p>Absolventen</p>
            <p>der Mittleren Reife mit einer abgeschlossenen Ausbildung</p>
        </div>
            ,
    },
    {
        icon:<IoDocumentTextOutline />,
        title:"Dokumente zur Anmeldung",
        content: <ul>
            <li>Lebenslauf in tabellarischer Form</li>
            <li> Zeugnis Mittlerer Abschluss in Form einer beglaubigten Kopie</li>
            <li> Nachweis eines Berufsabschlusses oder einer beruflichen Tätigkeit </li>
            <li> Abschlusszeugnis der Berufsschule in Form einer beglaubigten Kopie</li>
        </ul>
    },
    {
        icon: <FaRegCalendarCheck />,
        title: "Beginn",
        content: <div><p>18. August 2025</p>
        <p>nach den Sommerferien</p></div>
    },
    {
        icon:<LuBookOpenText />,
        title: "Schulungsinhalte",
        content: <ul>
            <li><span style={{ fontWeight: "500", color:"#49695d" }}>Beruflicher Pflichtlernbereich:</span>
                <br/>
                mehrere schwerpunktbezogene Themen- und Aufgabenfelder</li>
            <li><span style={{ fontWeight: "500", color:"#49695d" }}>Beruflicher Wahlpflichtbereich</span></li>
            <li><span style={{ fontWeight: "500", color:"#49695d" }}>Allgemeiner Lernbereich:</span>
                <br/>
                Deutsch, Englisch, Mathe <span style={{color:"#577562"}}>(je 4h)</span>
                <br/>
                PoWi, Naturwissenschaft, Ethik <span style={{color:"#577562"}}>(je 2h)</span>
                <br/>
                Sport <span style={{color:"#d9e3dd"}}>(1h)</span></li>
        </ul>
    },
    {
        icon: <GrVulnerability />,
        title: "Zielsetzung",
        content: "Im Mittelpunkt steht die Studier- und Berufsfähigkeit der Schülerinnen und Schüler."
    },
    {
        icon:<TbAccessPoint />,
        title: "Berechtigungen",
        content: <ul>
            <li>Zugang zu allen Studiengängen an einer Hochschule</li>
            <li>Zugang zu Bachelor- und Masterstudiengänge (gegliederte Studiengänge) an Universitäten</li>
            <li>Zugang zu mittleren und gehobenen Funktionen in Technik, Wirtschaft und Verwaltung</li>
        </ul>
    }
];



const FeaturesCard = ({ features }) => (
    <div className={cardStyles.card}>
        <div className={cardStyles.icon}>{features.icon}</div>
        <div className={cardStyles.title}>{features.title}</div>
        <div className={cardStyles.content}>{features.content}</div>

    </div>
);

const OrganisationsformB = () => {
    return(
        <div>
           <div className="wrapper">
                 <section className="wrapperContent">
                    <div className={styles.text}>
                        <h2>Organisationsform B</h2>
                        <p>Die einjährige Fachoberschule Organisationsform B baut auf einer Ausbildung auf. Der Unterricht erfolgt in der Regel vollschulisch. Aktuell werden Kerncurricula für die Fächer der Fachoberschule entwickelt. Es ist geplant, diese ab dem Schuljahr 2022/2023 Inkraftzusetzen. Sie werden damit im Schuljahr 2023/2024 erstmals die Grundlage für die zentrale Abschlussprüfung sein.</p>
                    </div>
                </section>
                 <section className="wrapperContent">
                    <div className={cardStyles.container}>
                        {features.map((features, index) => (
                            <FeaturesCard key={index} features={features} />
                        ))}
                    </div>
                </section>
           </div>
                <div className={styles.container}>

                    <div className="wrapperSM wrapperContent">
                        <h2 className={styles.caption}>Die Organisationsform B</h2>
                        <div className="grid">
                            <div className="col-12 lg:col-3">
                                <div className={styles.label}>Aufnahme</div>
                            </div>
                            <div className="col-12 lg:col-9">
                                <div className={styles.content}>
                                    Aufnahmevoraussetzung in die einjährige Organisationsform B der FOS sind neben den Abschlußnoten der Realschule wie in Form A vor allem die berufliche Erfahrung des Bewerbers. In der Regel wird diese durch den erfolgreichen Abschluss eines „einschlägig anerkannten Ausbildungsberufs” nachgewiesen. Andere Regeln können dies ersetzen. Dies auszuführen, führt an dieser Stelle zu weit. Wir beraten gern im Einzelfall.
                                </div>
                            </div>
                            <div className="col-12 lg:col-3">
                                <div className={styles.label}>Unterricht</div>
                            </div>
                            <div className="col-12 lg:col-9">
                                <div className={styles.content}>
                                    Der Unterricht in der Schule ist für beide Organisationsformen der FOS in diesem einen Jahr vor der Prüfung zur Fachoberschulreife gleich. Zwei Drittel der Wochenstunden sind den traditionellen Fächern vorbehalten (Deutsch, Mathematik, Englisch usw.), ein Drittel den beruflichen Lernbereichen, wobei die Arbeit mit und am PC ebenso wichtig ist wie der Erwerb von Kenntnissen in Wirtschaftsenglisch.
                                </div>
                            </div>
                            <div className="col-12 lg:col-3">
                                <div className={styles.label}>Abschluss</div>
                            </div>
                            <div className="col-12 lg:col-9">
                                <div className={styles.content}>
                                    Am Ende des Schuljahres wird durch schriftliche und mündliche Prüfungen die Fachhochschulreife, das Fachabitur, erworben.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    )
}
export default OrganisationsformB;